import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_ITEMS, LINKS } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0a0908]/80 border-b border-white/[0.06]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="flex items-center justify-between h-[68px]">
          {/* Logo */}
          <a href="#top" className="flex items-center gap-2.5 group">
            <img
              src="/copy-compass-icon.png"
              alt="Copy Compass"
              className="h-9 w-auto transition-transform duration-300 group-hover:scale-105 drop-shadow-[0_4px_12px_rgba(214,155,78,0.35)]"
            />
            <span className="font-display font-700 text-[1.05rem] gold-text tracking-tight">
              Copy Compass
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-9 absolute left-1/2 -translate-x-1/2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-[0.9rem] text-[#c7c1b5] hover:text-white transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:block">
            <a
              href={LINKS.requestInfo}
              className="inline-flex items-center gap-2 rounded-full bg-white text-[#0a0908] text-[0.88rem] font-600 px-5 py-2.5 hover:bg-[#f0ece3] hover:-translate-y-0.5 transition-all duration-200 shadow-[0_6px_20px_-8px_rgba(255,255,255,0.4)]"
            >
              Explore the specifics <span aria-hidden>→</span>
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setOpen((o) => !o)}
            className="md:hidden text-white p-2 -mr-2"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-[#0a0908]/95 backdrop-blur-xl border-t border-white/[0.06] px-5 py-6 space-y-4">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block text-[#c7c1b5] hover:text-white transition-colors text-base"
            >
              {item.label}
            </a>
          ))}
          <a
            href={LINKS.requestInfo}
            onClick={() => setOpen(false)}
            className="inline-flex items-center gap-2 rounded-full bg-white text-[#0a0908] font-600 px-5 py-2.5 mt-2"
          >
            Explore the specifics <span aria-hidden>→</span>
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
